import { Navigate } from 'react-router';

import { useAuth } from '../hooks/auth/useAuth';
import { AppRoutes } from '../shared/enums/app-routes';
import { validateTermsLatestVersion } from '../shared/helpers/validate-terms-latest-version';

type ProtectedGuardProps = {
  children: React.ReactNode;
};

const ProtectedGuard = ({ children }: ProtectedGuardProps) => {
  const { isLoading, isAuthenticated, user, isCompanyAdmin } = useAuth();

  if (!isLoading && !isAuthenticated) {
    return <Navigate to={AppRoutes.Login} />;
  }

  // Check if the user is admin and has latest version of terms and conditions
  if (
    user?.consentTermsVersion &&
    isCompanyAdmin &&
    !validateTermsLatestVersion(user?.consentTermsVersion)
  ) {
    // If user is admin and does not have the latest version of terms and conditions, redirect to terms of use dialog
    return <Navigate to={AppRoutes.Home} />;
  }

  return <>{children}</>;
};

export default ProtectedGuard;
